// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminDashboardPage_container__3trkh"};